//Action Types
export const WORKFLOW_TEMPLATE_COLUMN_INFO = 'WORKFLOW_TEMPLATE_COLUMN_INFO';
export const WORKFLOW_TEMPLATE_COLUMN_INFO_SUCCESS =
  'WORKFLOW_TEMPLATE_COLUMN_INFO_SUCCESS';
export const WORKFLOW_TEMPLATE_COLUMN_INFO_ERROR =
  'WORKFLOW_TEMPLATE_COLUMN_INFO_ERROR';
export const WORKFLOW_TEMPLATE_ITEMS_SELECTED =
  'WORKFLOW_TEMPLATE_ITEM_SELECTED';
export const RELOAD_GRID_WF = 'RELOAD_GRID_WF';
